<template lang="pug">
v-dialog(
  max-width="500px",
  v-model="mode.restaurantDialog",
  persistent,
  scrollable,
  transition="dialog-left-transition"
)
  v-card
    v-card-title.headline.grey.lighten-2.pa-1(primary-title) {{  formTitle(&apos;Restaurant&apos;)  }}
    v-card-text.pa-1
      v-form.pa-1(ref="restaurant")
        v-form-base#restaurantForm(
          :value="editedItem",
          :schema="schema",
          @input:restaurantForm="onFormInput"
        )
          user-selector(
            slot="slot-item-key-_managerId",
            label="Manager In-charge",
            :context="{ selectedId: editedItem._managerId, users: users.filter((u) => u.roles.includes('RM')) }",
            v-on:change="maanagerChanged($event)"
          )
    v-divider
    v-card-actions
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.ACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="deActivate(dialogKey)"
      ) De-Activate
      v-btn(
        color="primary",
        v-if="editedItem.id && editedItem.status === STATUSES.INACTIVE",
        :disabled="isDirty",
        text,
        v-on:click.stop="editedItem.status = STATUSES.ACTIVE; save(dialogKey)"
      ) Activate
      v-spacer
      v-btn(
        color="primary",
        v-if="isDirty",
        text,
        v-on:click.stop="cancel(dialogKey)"
      ) Cancel
      v-btn(
        color="primary",
        v-if="!isDirty",
        text,
        v-on:click.stop="cancel(dialogKey)"
      ) Close
      v-btn(
        color="primary",
        :disabled="!isDirty",
        text,
        v-on:click.stop="save(dialogKey)"
      ) Save
</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "restaurant-dialog",
  mixins: [storeMixin, dialogsMixin],
  beforeMount() {
    if (!this.editedItem.id) {
      Object.assign(this.editedItem, this.defaultItem);
    }
  },
  data() {
    return {
      collectionName: "restaurants",
      dialogKey: "restaurantDialog",
      defaultItem: {
        name: "",
        _managerId: "",
        managerName: "",
        mobile1: "",
        mobile2: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pin: "",
        notes: "",
        status: 0,
      },
    };
  },
  computed: {
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            disabled: true,
            rules: [
              this.required("Restaurant Code is required"),
              this.minLen(2),
              this.maxLen(8),
            ],
          },
          name: {
            type: "text",
            label: "Name",
            flex: 9,
            sort: 2,
            offset: 1,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("Restaurant Name is required"),
              this.minLen(10),
              this.maxLen(40),
            ],
          },
          mobile1: {
            type: "text",
            label: "Primary Mobile#",
            flex: 5,
            sort: 3,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("Mobile1 is required"),
              this.minLen(10),
              this.maxLen(10),
            ],
          },
          mobile2: {
            type: "text",
            label: "Alternate Mobile#",
            flex: 5,
            offset: 1,
            sort: 4,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("Mobile2 is required"),
              this.minLen(10),
              this.maxLen(10),
            ],
          },
          _managerId: { type: "text", sort: 5, flex: 12, hidden: false },
          managerName: { type: "text", sort: 6, flex: 12, hidden: true },
          addressLine1: {
            type: "text",
            label: "Address Line1",
            flex: 12,
            sort: 7,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("Address Line1 is required"),
              this.minLen(3),
              this.maxLen(40),
            ],
          },
          addressLine2: {
            type: "text",
            label: "Area",
            flex: 5,
            sort: 8,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("Address Line2 is required"),
              this.minLen(3),
              this.maxLen(40),
            ],
          },
          city: {
            type: "text",
            label: "City",
            flex: 5,
            offset: 1,
            sort: 9,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("City is required"),
              this.minLen(3),
              this.maxLen(40),
            ],
          },
          state: {
            type: "text",
            label: "State",
            flex: 5,
            sort: 10,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required("State is required"),
              this.minLen(3),
              this.maxLen(20),
            ],
          },
          pin: {
            type: "text",
            label: process.env.VUE_APP_POSTAL_LABEL,
            flex: 5,
            offset: 1,
            sort: 11,
            disabled: !["GA"].includes(
              this.selectedUser && this.selectedUser.role
            ),
            rules: [
              this.required(`${process.env.VUE_APP_POSTAL_LABEL} is required`),
              this.minLen(4),
              this.maxLen(10),
            ],
          },
          status: {
            type: "select",
            label: "Status",
            items: ["Inactive", "Active", "Open", "Closed"],
            flex: 3,
            sort: 12,
            rules: [this.required("Status is required")],
            hidden: true,
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 12,
            sort: 13,
            rules: [this.maxLen(200)],
          },
        },
        this.baseSchema
      );
    },
  },
  methods: {
    maanagerChanged(user) {
      this.editedItem._managerId = user ? user.id : null;
      this.editedItem.managerName = user ? user.fullName : null;
      this.isDirty = true;
    },
    async save() {
      const savedRestaurant = await this.saveSync();
      this.selectRestaurant(savedRestaurant);
      this.isDirty = false;
      this.$emit("refresh", savedRestaurant);
      this.cancel(this.dialogKey);
    },
  },
};
</script>